// Behavior constants for conditional logic throughout the app
export const BEHAVIOR_APLICACAO = "aplicacao" as const;
export const BEHAVIOR_RETORNO = "retorno" as const;
export const BEHAVIOR_BANHO_TOSA = "banho_tosa" as const;
export const BEHAVIOR_PADRAO = "padrao" as const;

/**
 * Returns true if the appointment matches the selected behavior filters.
 * When no filters are selected, all appointments match.
 * Matches against `clinic_appointment_type.behavior` when available,
 * falling back to the raw `type` string for backward compatibility.
 */
export function matchesAppointmentTypeFilter(
  appointmentType: string | null | undefined,
  selectedBehaviors: string[],
  appointmentBehavior?: string | null,
  appointmentTypeId?: string | null,
): boolean {
  if (selectedBehaviors.length === 0) return true;
  if (appointmentTypeId && selectedBehaviors.includes(appointmentTypeId)) return true;
  const behavior = appointmentBehavior ?? appointmentType ?? "";
  return selectedBehaviors.includes(behavior);
}
